import styled from "styled-components";
import { Link, Grid } from "@material-ui/core";

export const STItemGrid = styled(Grid)`
  && {
    display: flex;
    align-items: center;
  }
`;

export const STImg = styled.img`
  {
    height: 20px;
    wight: 20px;
    margin-right: 5px;
  }
`;

export const STLink = styled(Link)`
  {
    color: #547F00 !important; 
    text-decoration:none !important
    width: 100%;
    display: flex !important;
    align-items: center;
  }
`;

export const STGrid = styled(Grid)`
  && {
    height: 100%;
    padding-bottom: 16px;
  }
`;